module.exports = __webpack_public_path__ + "media/features/calendar-dfaf08d0.jpg";